export default {
  regular: 'Comfortaa Regular',
  bold: 'Comfortaa Bold',
  regular_roboto: 'Roboto Regular',
  bold_roboto: 'Roboto Bold',
};
